import React, { useState, useEffect, useContext } from "react";
import Header from "../Header";
import { ParallaxProvider } from "react-scroll-parallax";
import AdvancedBanner from "../AdvancedBanner";
import { DataContext } from "../../App";
import HeadingSection from "../HeadingSection";
import { HashLink as LinkHash } from 'react-router-hash-link';
import Seo from "../Seo";

const TemplateExperienceSlider = (props) => {

    const context = useContext(DataContext)
    const isMobileTablet = window.matchMedia("screen and (max-width: 991px)").matches;

    const [isSticky, setIsSticky] = useState(false);
    const [isNegative, setIsNegative] = useState(false);

    const experiences = context.experiences && context.experiences.filter((x) => x.category === props.item.category && x.status === "active" ).sort((a, b) => a.priority < b.priority ? 1 : -1);

    useEffect(() => {
        const handleCheckShow = (e) => {

            if (window.scrollY > (window.innerHeight + 100)) {
                setIsSticky(true);
              } else {
                setIsSticky(false);
              }
              if (window.scrollY > (window.innerHeight + window.innerHeight + 100)){
                if(e.type ===  "scroll"){
                    setIsNegative(false);
                  }else if(e.type === "mouseover"){
                    setIsNegative(false);
                  }else if(e.type === "scrollend"){
                    setIsNegative(true);
                  }
              }else{
                setIsNegative(false);
              }

        };

        document.addEventListener("mouseover", handleCheckShow);
        window.addEventListener("scroll", handleCheckShow);
        window.addEventListener("scrollend", handleCheckShow);
        return () => {
            window.removeEventListener("scroll", handleCheckShow);
        };
    }, []);

    return (
        <>
            <Seo
                title={props.item.seoInformation?.title ?? "Memorable experiences | Feeling Italy"}
                description={props.item?.seoInformation?.metaDescription ?? "Discover exclusive concierge services with Feeling Italy. From private chefs and luxury transfers to personalized tours and unique experiences, let us make your Mediterranean vacation truly unforgettable."}
                keywords={props.item?.seoInformation?.keywords ?? "Concierge Services, Feeling Italy Concierge, Private Chef Italy, Luxury Transfers Amalfi Coast, Personalized Tours Italy, Exclusive Mediterranean Experiences, Tailored Travel Services, Amalfi Coast Luxury Services, Custom Travel Assistance, Premium Guest Experiences"}
                url={window.location.href}
            />
            <Header background={"transparent"} isStatic={true} />
            <HeadingSection data={props.item.internalInformation} />

            <div className="background-white w-100" id="menu-internal">
                <div className="container-fluid p-0">
                    <div className={`row background-white m-0 w-100 z-1 ${isSticky ? "position-fixed top-0" : ""}`}>
                        <div className="col-12 text-center">
                            {!isMobileTablet && (
                                <div className={`d-flex justify-content-center header-internal ${isNegative ? "header-internal-negative" : ""}`}>
                                    {experiences.map((item, index) => (
                                            <LinkHash key={index} className="lineEffectBlack text-uppercase text-black me-5" smooth to={"#"+(item?.linkMenu?.url ?? "")} target="_self">
                                                {item?.linkMenu?.text ?? ""}
                                            </LinkHash>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <ParallaxProvider>
                {experiences.map((item, index) => (
                    <React.Fragment key={index}>
                        <section id={(item?.linkMenu?.url ?? "")}>
                            <AdvancedBanner item={item} cta={{text: item.cta.text, url: item.seoInformation.linkUrl, target: "_self"}} title={item.title} description={item.description} urlImage={(item.heading?.image && (item.heading?.image[0]?.objectUrl ?? ""))}/>                               
                        </section>
                    </React.Fragment>
                ))}
            </ParallaxProvider>


        </>
    );
};

export default TemplateExperienceSlider;
